"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AssignEmployeesBody () {
        return AssignEmployeesBody;
    },
    get BulkPatchRoleCompetenciesBody () {
        return BulkPatchRoleCompetenciesBody;
    },
    get CheckRoleNameQuery () {
        return CheckRoleNameQuery;
    },
    get CreateRoleBody () {
        return CreateRoleBody;
    },
    get ListRoleEmployeesQuery () {
        return ListRoleEmployeesQuery;
    },
    get ListRoleOptionsQuery () {
        return ListRoleOptionsQuery;
    },
    get ListRolesQuery () {
        return ListRolesQuery;
    },
    get PatchRoleCompetencyBody () {
        return PatchRoleCompetencyBody;
    },
    get RoleSortBySchema () {
        return RoleSortBySchema;
    },
    get UpdateRoleBody () {
        return UpdateRoleBody;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../base");
const _constants = require("../competency-assignments/constants");
const _constants1 = require("./constants");
const RoleSortBySchema = _zod.z.enum([
    "name",
    "description",
    "status",
    "employees_count",
    "competencies_count"
]);
const ListRolesQuery = _zod.z.object({
    name: _zod.z.string().optional(),
    status: (0, _base.createStatusFilterSchema)([
        "active",
        "archived"
    ]),
    sortBy: RoleSortBySchema.default("name"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("asc"),
    limit: _zod.z.coerce.number().int().min(1).max(500).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
const ListRoleOptionsQuery = _zod.z.object({
    name: _zod.z.string().optional(),
    limit: _zod.z.coerce.number().int().min(1).max(500).default(100),
    skip: _zod.z.coerce.number().int().min(0).default(0),
    // Comma-separated role ids for resolving saved-filter labels; when present the handler matches
    // these ids (archived included) instead of the active-only name search.
    ids: _zod.z.preprocess((val)=>typeof val === "string" ? val.split(",").filter(Boolean) : val, _zod.z.array(_utilsisomorphic.transformObjectId)).optional()
});
const RoleCompetencyEntryRequest = _zod.z.object({
    competency_id: _utilsisomorphic.transformObjectId,
    expected_level: _zod.z.number().int().min(1).max(_models.MAX_COMPETENCY_LEVELS).nullable().default(null)
});
// Sanitize BEFORE validating min(1) — the write boundary's canonical spelling (models
// sanitizeRoleName) strips invisibles JS trim() keeps, so an invisible-only paste 400s as
// "required" here instead of reading as a name collision downstream, and create/update/check
// all validate the spelling that will actually persist. Pipe ensures min/max see that value.
const TrimmedRoleName = _zod.z.string().transform(_utilsisomorphic.sanitizeRoleName).pipe(_zod.z.string().min(1).max(_models.MAX_ROLE_NAME_LENGTH));
const CheckRoleNameQuery = _zod.z.object({
    name: TrimmedRoleName,
    excludeId: _utilsisomorphic.transformObjectId.optional()
});
const CreateRoleBody = _zod.z.object({
    name: TrimmedRoleName,
    description: _zod.z.string().max(_constants1.MAX_ROLE_DESCRIPTION_LENGTH).default(""),
    competencies: _zod.z.array(RoleCompetencyEntryRequest).default([])
});
const UpdateRoleBody = _zod.z.object({
    name: TrimmedRoleName.optional(),
    description: _zod.z.string().max(_constants1.MAX_ROLE_DESCRIPTION_LENGTH).optional(),
    competencies: _zod.z.array(RoleCompetencyEntryRequest).optional()
});
const PatchRoleCompetencyBody = _zod.z.discriminatedUnion("op", [
    _zod.z.object({
        op: _zod.z.literal("upsert"),
        competency_id: _utilsisomorphic.transformObjectId,
        expected_level: _zod.z.number().int().min(1).max(_models.MAX_COMPETENCY_LEVELS).nullable().default(null)
    }),
    _zod.z.object({
        op: _zod.z.literal("remove"),
        competency_id: _utilsisomorphic.transformObjectId
    })
]);
// PATCH /v1/roles/:id/competencies/bulk
// Its own entry shape: RoleCompetencyEntryRequest defaults a missing expected_level to null,
// which here would cascade a clear to every holder instead of rejecting the request.
const BulkRoleCompetencyEntryRequest = _zod.z.object({
    competency_id: _utilsisomorphic.transformObjectId,
    expected_level: _zod.z.number().int().min(1).max(_models.MAX_COMPETENCY_LEVELS).nullable()
});
const BulkPatchRoleCompetenciesBody = _zod.z.object({
    competencies: _zod.z.array(BulkRoleCompetencyEntryRequest).min(1).max(_constants.MAX_BULK_LEVEL_ENTRIES)
});
const AssignEmployeesBody = _zod.z.object({
    user_ids: _zod.z.array(_utilsisomorphic.transformObjectId).min(1)
});
const ListRoleEmployeesQuery = _zod.z.object({
    search: _zod.z.string().optional(),
    limit: _zod.z.coerce.number().int().min(1).max(500).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0)
});
